import { Component, OnInit } from '@angular/core';
import { JobsService, VmeInboxJobsService } from '../../../services';
import { ActivatedRoute } from '@angular/router';
import { JobScreenCommonService } from '../common/job-screen-common.service';
import { CustomerJobScreenJob } from '../../../interfaces/screen-specific/job-screen';

@Component({
  selector: 'app-customer-job-screen',
  templateUrl: './customer-job-screen.component.html',
  styleUrls: ['./customer-job-screen.component.scss'],
})
export class CustomerJobScreenComponent implements OnInit {
  private jobId: number;
  job: CustomerJobScreenJob = null;

  constructor(
    public commonService: JobScreenCommonService,
    private jobService: JobsService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.jobId = parseInt(this.route.snapshot.paramMap.get('id'));
    this.jobService.get(this.jobId).then((job) => {
      this.job = job;
    });
  }
}
